import { BaseResourceStorage } from "../../models/base-resource.storage";
import { Rcms } from "./rcms.model";

export class RcmsStorage extends BaseResourceStorage {
  constructor(
    public visivel_transparencia?: boolean,
    public assinatura?: boolean,
    public rcms?: Rcms,
    public arquivo?: any, // campo virtual
  ) {
    super();
  }

  static converteJson(json: any): RcmsStorage {
    return Object.assign(new RcmsStorage(), json);
  }
}